/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_ResumeInputs */

const en_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const de_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf`)
};

const fr_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum`)
};

const it_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum Vitae`)
};

const nl_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const pl_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelo`)
};

const da_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const sv_jobs_resume = /** @type {(inputs: Jobs_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Jobs_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_resume = /** @type {((inputs?: Jobs_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_resume(inputs)
	if (locale === "fr") return fr_jobs_resume(inputs)
	if (locale === "es") return es_jobs_resume(inputs)
	if (locale === "it") return it_jobs_resume(inputs)
	if (locale === "nl") return nl_jobs_resume(inputs)
	if (locale === "pl") return pl_jobs_resume(inputs)
	if (locale === "fi") return fi_jobs_resume(inputs)
	if (locale === "da") return da_jobs_resume(inputs)
	if (locale === "sv") return sv_jobs_resume(inputs)
	return en_jobs_resume(inputs)
});